/**
 * Shared allowlist of AI Security pages that get the full Account +
 * Environment global filter (dropdown enabled, chip strip rendered in
 * "full" mode instead of "time-only"). See tech-spec.md §8.
 *
 * Enumerated explicitly rather than a single `/ai-applications` prefix —
 * out-of-scope AI pages (Detection Rules, Component Catalog, CISO
 * Scorecard, Compliance) must NOT get the dropdown or chips (Q4/Q6).
 */

export type MatchMode = 'exact' | 'prefix'

export type AiAccountEnvFilterPathEntry = {
  path: string
  matchMode: MatchMode
}

export const AI_ACCOUNT_ENV_FILTER_PATHS: ReadonlyArray<AiAccountEnvFilterPathEntry> =
  [
    { path: '/ai-applications/identities', matchMode: 'prefix' },
    { path: '/ai-applications/findings', matchMode: 'prefix' },
    { path: '/ai-applications/catalog', matchMode: 'exact' }, // index only, not /catalog/:id
    { path: '/ai-applications/security-concerns', matchMode: 'prefix' },
    { path: '/ai-applications/incidents', matchMode: 'exact' }, // exclude /incidents-old
    { path: '/ai-applications/shadow-ai', matchMode: 'exact' },
  ]

// @purpose Determine whether a pathname is one of the six AI Security pages that get the full Account/Environment global filter (dropdown + chips)
export const onAiAccountEnvFilterPath = (pathname: string): boolean => {
  const p = pathname.replace(/\/$/, '') || '/' // tolerate trailing slash
  return AI_ACCOUNT_ENV_FILTER_PATHS.some(entry =>
    entry.matchMode === 'exact'
      ? p === entry.path
      : // Path-segment boundary: a bare startsWith would also match a
        // sibling path that merely shares the prefix (e.g.
        // /ai-applications/identities-old), so require p to equal the
        // entry path or continue with '/'.
        p === entry.path || p.startsWith(entry.path + '/'),
  )
}
